/**
 * Pipedrive Navigation Configuration
 * Navigation structure for the Pipedrive data viewer
 */

import { LayoutDashboard, Building2, Calendar, Package } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface PipedriveNavItem {
  label: string
  href: string
}

export interface PipedriveNavGroup {
  id: string
  label: string
  icon: LucideIcon
  href?: string
  items?: PipedriveNavItem[]
  defaultExpanded?: boolean
  standalone?: boolean
}

export const pipedriveNavigationGroups: PipedriveNavGroup[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard,
    href: '/pipedrive',
    standalone: true,
  },
  {
    id: 'crm',
    label: 'CRM',
    icon: Building2,
    defaultExpanded: true,
    items: [
      { label: 'Organizations', href: '/pipedrive/organizations' },
      { label: 'People', href: '/pipedrive/people' },
      { label: 'Deals', href: '/pipedrive/deals' },
      { label: 'Leads', href: '/pipedrive/leads' },
    ],
  },
  {
    id: 'activities',
    label: 'Activities',
    icon: Calendar,
    defaultExpanded: true,
    items: [
      { label: 'Activities', href: '/pipedrive/activities' },
      { label: 'Notes', href: '/pipedrive/notes' },
    ],
  },
  {
    id: 'catalog',
    label: 'Catalog',
    icon: Package,
    defaultExpanded: false,
    items: [
      { label: 'Products', href: '/pipedrive/products' },
      { label: 'Files', href: '/pipedrive/files' },
    ],
  },
]
